import { get, post, put } from "./api";

export const getPayments = (params) => {
    return get("/orders/with-payments", { params });
};

export const exportPayments = (params) => {
    return get("/orders/with-payments", { params, responseType: 'blob' });
};

export const getPendingPaymentApprovals = (params) => {
    return get("/payments/pending-approvals", { params });
};

export const approvePayment = (id) => {
    return put(`/payments/${id}/approve`);
};

export const rejectPayment = (id, data) => {
    return put(`/payments/${id}/reject`, data);
};

export const updatePayment = (id, data) => {
    return put(`/payments/${id}`, data);
};

export const getOrderPayments = (orderId) => {
    return get(`/orders/${orderId}/payments`);
};

export const addOrderPayment = (orderId, data) => {
    return post(`/orders/${orderId}/payments`, data);
};
